import React from "react";
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import { overlayButtonStyle } from "../../../utils/layout";

function BackToGameList() {
  const navigate = useNavigate();
  return (
    <>
    <Button
      onClick={() => navigate("/home")}
      style={{ ...overlayButtonStyle(0), zIndex: 10000 }}
    >
      Back Home
    </Button>
    <Button
        onClick={() => navigate('/games')}
        style={{ ...overlayButtonStyle(1), zIndex: 10000 }}
        variant="warning"
      >
        Skip Game
      </Button>
      
    </>
  );
}

export default BackToGameList;
